/* Backup Code for Auto Status */
const html = document.documentElement;

// Only apply auto theme if _color_schema is not set
if (!localStorage.getItem('_color_schema')) {
  const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

  if (isDarkMode) {
    html.setAttribute('data-scheme-custom', 'dark');
  } else {
    html.setAttribute('data-scheme-custom', 'light');
  }
}

// Remove attribute on theme toggle click
document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.theme__toggle');
  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      html.removeAttribute('data-scheme-custom');
    });
  });
});

setTimeout(() => {
    html.classList.add('all-loaded');
}, 100)
/* Backup Code for Auto Status */
